import React from 'react';

import { AppStoreBadge } from '@reverbdotcom/commons/src/components/app_store_badge';

interface IProps {
  userLocale: string;
  linkLocation: 'homepage' | 'sale-ineligible' | 'homepage-experiment';
}

const links = {
  homepage: {
    ios: 'https://apps.apple.com/app/reverb-buy-sell-music-gear/id674604876',
    android: 'https://play.google.com/store/apps/details?id=com.reverb.app',
  },
  'sale-ineligible': {
    ios: 'https://apps.apple.com/app/reverb-buy-sell-music-gear/id674604876',
    android: 'https://play.google.com/store/apps/details?id=com.reverb.app',
  },
  'homepage-experiment': {
    ios: 'https://reverb.onelink.me/XhtR/wdoeb4wr',
    android: 'https://reverb.onelink.me/XhtR/wdoeb4wr',
  },
};

export function AppleAppStoreLink(props: IProps) {
  const link = links[props.linkLocation]?.ios;

  return (
    <a
      className="d-inline-block"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <AppStoreBadge brand="apple" locale={props.userLocale.slice(0, 2) || 'en'} />
    </a>
  );
}

export function GooglePlayStoreLink(props: IProps) {
  const link = links[props.linkLocation]?.android;

  return (
    <a
      className="d-inline-block"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <AppStoreBadge brand="google" locale={props.userLocale.slice(0, 2) || 'en'} />
    </a>
  );
}
